<!--  -->
<template>
  <div class="sp_view">
    <div class="tabselecr_box">
      <div class="search_box">
        <el-input v-model="query.suite_id" clearable style="width:300px;" placeholder="请输入应用id" />
        <el-input v-model="query.keywords" clearable style="width:400px;margin:0 10px" placeholder="请输入企业名称/企业id" />
        <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
        <!-- <el-button type="warning" icon="el-icon-thumb" @click="anthall">授权</el-button> -->
      </div>
      <div>
        <!-- <el-button type="success" icon="el-icon-plus" @click="add(1)">新增</el-button> -->
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      max-height="500"
      border
    >
      <el-table-column
        prop="corp_name"
        label="企业名称"
        align="center"
        width="280px"
      />
      <el-table-column
        prop="corp_type"
        label="授权方企业类型"
        align="center"
        width="150px"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.corp_type === 'verified'">认证号</div>
          <div v-if="scope.row.corp_type === 'unverified'">注册号</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="subject_type_text"
        label="企业类型"
        align="center"
        width="100"
      />
      <el-table-column
        prop="corp_id"
        label="企业id"
        align="center"
        width="320px"
      />
      <el-table-column
        prop="suite_id"
        label="应用id"
        align="center"
      />

      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
      />
      <el-table-column
        prop="realName"
        label="创建人"
        align="center"
        width="100"
      />
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="chooser(scope.row)">选择</el-button>
        </template>
      </el-table-column>

    </el-table>

    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { spCorplist } from '@/api/officialaccount.js'
export default {
  name: 'Enterprise',
  components: { PaginationRight },
  data() {
    return {
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        pageSize: 10,
        keywords: null,
        suite_id: null
      }
    }
  },
  created() {
    this.list()
  },
  mounted() {

  },
  methods: {
    send() {
      this.list()
    },
    async list() {
      this.loading = true
      const data = await spCorplist(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.suite_id = null
      this.query.keywords = null
      this.list()
    },
    chooser(item) {
      this.$emit('callbackqiwei', item)
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sp_view{
  padding: 30px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.qr_box{
  text-align: center;
}
</style>
